const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
  CHANGE_ACTIVE_WORKSPACE: 'user/CHANGE_ACTIVE_WORKSPACE',
  LOCAL_LOGOUT: 'user/LOCAL_LOGOUT',
};

export default actions
